import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CoverageNetwork } from '../../../../shared/models/coverage.model';

@Component({
  standalone: false,
  selector: 'app-coverage-table-network-cell',
  templateUrl: './coverage-table-network-cell.component.html',
  styleUrls: ['./coverage-table-network-cell.component.scss'],
  host: {
    class: 'w-100',
  },
})
export class CoverageTableNetworkCellComponent implements ICellRendererAngularComp {
  online = false;
  formattedText = '';

  get statusClassName(): string {
    return this.online ? 'text-success-s2' : 'text-error-r2';
  }

  agInit(params: ICellRendererParams<CoverageNetwork>): void {
    this.setData(params);
  }

  refresh(params: ICellRendererParams<CoverageNetwork>): boolean {
    this.setData(params);
    return true;
  }

  private setData(params: ICellRendererParams<CoverageNetwork>) {
    const data = params.data!;
    this.online = data.online;
    this.formattedText = `${data.countryName}(${data.mcc})/${data.providerName}(${data.mnc})`;
  }
}
